import { makeObservable, observable } from 'mobx';
import { ApiStore } from './api-store';

export class ApiEndpointCallStatesStore {
  @observable inFlightStatusMap = new Map<keyof ApiStore, boolean>();

  constructor() {
    makeObservable(this);
  }

  setIsInFlight(operation: keyof ApiStore, isInFlight: boolean) {
    this.inFlightStatusMap.set(operation, isInFlight);
  }
}
